<template>
  <loading-page v-if="loading" />

  <policies-form
    v-else
    details
    @edit="onEdit"
    @close="onClose"
  />
</template>
<script>
import PoliciesForm from './CachePoliciesForm.vue'
import redirectError from '@/services/redirectError'

export default {
  name: 'RequestPolicyEdit',
  components: { PoliciesForm },
  data() {
    return {
      cacheId: null,
    }
  },
  computed: {
    loading() {
      return this.$store.state.cachePolicies.gettingPolicy
    },
  },
  created() {
    this.cacheId = this.$route.params.cacheId
    this.$store.dispatch('cachePolicies/getCachePolicy', this.cacheId)
      .catch(err => redirectError(err, this.$router, this.$route.path))
  },
  methods: {
    onEdit(policy) {
      this.$store.dispatch('cachePolicies/updateCachePolicy',
        {
          id: policy.id,
          name: policy.name,
          comment: policy.comment,
          minimumTTL: policy.minimumTTL,
          maximumTTL: policy.maximumTTL,
          defaultTTL: policy.defaultTTL,
          browserMinimumTTL: policy.browserMinimumTTL,
          browserMaximumTTL: policy.browserMaximumTTL,
          browserDefaultTTL: policy.browserDefaultTTL,
          addBrowserCache: policy.addBrowserCache,
          headerPolicyId: policy.headerPolicyId,
          headers: policy.headers,
          cookiePolicyId: policy.cookiePolicyId,
          cookies: policy.cookies,
          queryStringPolicyId: policy.queryStringPolicyId,
          queryStrings: policy.queryStrings,
        })
        .then(() => {
          this.successToast('Cache policy was updated')
          this.onClose()
        }).catch(error => { this.errorToast(error.response?.data?.errors[0] || 'Something went wrong while updating policy.') })
    },
    onClose() {
      this.$router.push({ name: 'cache-policies' })
    },
  },
}
</script>
